module.exports = __webpack_public_path__ + "assets/img/binding-2-sm.038d5cce.jpg";